import React, {  Component } from 'react';
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';


import { mudarStream, mudarDevices, mudarCamModal } from '../actions/AppActions';
import { connect } from 'react-redux';
import { getLanguageTexts, getSelectedLanguage } from '../language';

class ChangeCamModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedLanguage: getSelectedLanguage()
        };
    }

    componentDidMount() {
        window.addEventListener('candidate_language_change', this.handleLanguageChange);
    }

    componentWillUnmount() {
        window.removeEventListener('candidate_language_change', this.handleLanguageChange);
    }

    handleLanguageChange = (event) => {
        this.setState({ selectedLanguage: event.detail || getSelectedLanguage() });
    }

   
    closeModal() {
        this.props.mudarCamModal(false);
    }

    change_device(event) {
        this.props.mudarDevices({device_select_mic:this.props.device_select_mic, devices_camera: this.props.devices_camera, devices_mic: this.props.devices_mic, device_select: event.target.value })

        // console.log(event);
        localStorage.setItem("deviceId", event.target.value);

        navigator.mediaDevices.getUserMedia({ video: { deviceId: {exact:event.target.value},frameRate: 4,
            facingMode: "user",
            width: 320,
            height: 240 }, audio: {deviceId:{exact:this.props.device_select_mic}} }).
            then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this));
    }

    change_device_mic(event) {
        this.props.mudarDevices({device_select:this.props.device_select, devices_camera: this.props.devices_camera, devices_mic: this.props.devices_mic, device_select_mic: event.target.value })

        // console.log(event);
        localStorage.setItem("deviceIdMic", event.target.value);

        navigator.mediaDevices.getUserMedia({ video: { deviceId: {exact:this.props.device_select},frameRate: 4,
            facingMode: "user",
            width: 320,
            height: 240 }, audio: {deviceId:{exact:event.target.value}} }).
            then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this));
    }
    handleSuccess(stream) {
        console.log('finalizado stream3')

        if (this.props.stream != null) {
            this.props.stream.oninactive = () => {}
            this.props.stream.getTracks().map((track)=>{
                track.stop();
            })
        }
        // screenshotButton.disabled = false;
        // window.location="/processos_user"
        this.props.mudarStream(stream);
        this.props.changeStateParent({ left_movement:false,face_detected:false,right_movement:false,center_movement:false,audio_detected:false });
    }

    handleError(stream) {
        console.log(stream);
        const t = getLanguageTexts(this.state.selectedLanguage);
        let msg = '';
        localStorage.removeItem("deviceId");
        localStorage.removeItem("deviceIdMic");
        if (stream.toString().includes('Permission denied')) {
            msg = t.camera_permission_denied;
        }
        else if (stream.toString().includes('Permission dismissed')) {
            msg = t.camera_permission_dismissed;
        }
        else if (stream.toString().includes('Could not start video source')) {
            msg = t.camera_start_error;
        }
        else if (stream.toString().includes('Could not start audio source')) {
            msg = t.microphone_start_error;
        }
        else if (stream.toString().includes('NotFoundError')) {
            msg = t.media_not_found;
        }
        else {
            msg = stream.toString();
        }

    }

    render() {
        console.log(this.props.change_cam_modal)
        const t = getLanguageTexts(this.state.selectedLanguage);
        return (
            <div>
                {/* <Button color="danger" onClick={toggle}>{buttonLabel}</Button> */}
                <Modal show={this.props.change_cam_modal} onHide={this.closeModal.bind(this)} centered dialogClassName="candidate-device-modal" >
                    <Modal.Header >
                        <Modal.Title>
                            <i className="mdi mdi-tune-vertical"></i>
                            {t.camera_microphone}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group mb-0">
                            <div className="candidate-device-field">
                                <label htmlFor="cameras"><i className="mdi mdi-video-outline"></i> {t.camera}</label>
                                <select value={this.props.device_select} disabled={this.props.devices_camera.length == 0} className="form-control" id="cameras" onChange={this.change_device.bind(this)}>
                                    {this.props.devices_camera.length == 0 && <option value="">{t.no_camera_found}</option>}
                                    {this.props.devices_camera.map((item, id) => (
                                        <option key={id} value={item.deviceId}>{item.label || t.camera_option.replace('{number}', id + 1)}</option>

                                    ))}
                                </select>
                            </div>
                            <div className="candidate-device-field">
                                <label htmlFor="mics"><i className="mdi mdi-microphone-outline"></i> {t.microphone}</label>
                                <select value={this.props.device_select_mic} disabled={this.props.devices_mic.length == 0} className="form-control" id="mics" onChange={this.change_device_mic.bind(this)}>
                                    {this.props.devices_mic.length == 0 && <option value="">{t.no_microphone_found}</option>}
                                    {this.props.devices_mic.map((item, id) => (
                                        <option key={id} value={item.deviceId}>{item.label || t.microphone_option.replace('{number}', id + 1)}</option>

                                    ))}
                                </select>
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        {/* <Button color="primary" onClick={this.change_device.bind(this)}>Alterar</Button>{' '} */}
                        <Button variant="secondary" onClick={this.closeModal.bind(this)}>
                            <i className="mdi mdi-close"></i>
                            {t.close}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

}

const mapsStateToProps = (state) => (
    {
        change_cam_modal: state.AppReducer.change_cam_modal,
        devices_camera: state.AppReducer.devices_camera,
        devices_mic: state.AppReducer.devices_mic,
        device_select: state.AppReducer.device_select,
        device_select_mic: state.AppReducer.device_select_mic,

        stream: state.AppReducer.stream,
    }
);

export default connect(mapsStateToProps, { mudarCamModal, mudarDevices, mudarStream })(ChangeCamModal);
